<div class="flex flex-col gap-6 w-full container max-w-7xl">
  <div class="flex flex-col gap-4 items-center">
    <p class="sb-aggro text-sm lg:text-lg text-zinc-500">Advertising Schedule</p>
    <h1 class="text-xl text-zinc-800 font-extrabold lg:text-4xl">방송 스케줄</h1>
  </div>

  <!-- 상단 네비게이션 -->
  <div class="flex flex-col gap-4 lg:flex-row lg:justify-between items-center">
    <!-- 연도 네비게이션 -->
    <div class="flex items-center gap-3 w-full justify-center lg:justify-start">
      <button
        class="cursor-pointer size-5 lg:size-6 rounded-full bg-zinc-300 items-center justify-center flex"
        (click)="prevYear()">
        <app-icon name="material-symbols:arrow-back-ios-new" class="size-3! text-white" />
      </button>
      <h1 class="text-xl lg:text-2xl text-zinc-800">{{ currentYear() }}년</h1>
      <button
        class="cursor-pointer size-5 lg:size-6 rounded-full bg-zinc-300 items-center justify-center flex"
        (click)="nextYear()">
        <app-icon name="material-symbols:arrow-forward-ios" class="size-3! text-white" />
      </button>
    </div>

    <!-- 검색 -->
    <div class="search-box">
      <app-icon name="ic:round-search" class="size-5! text-zinc-400"></app-icon>
      <input type="text" placeholder="검색어를 입력하세요" (input)="onSearchInput($event)" />
    </div>
  </div>

  <!-- 방송 스케줄 목록 -->
  <div class="list-content">
    @if (filteredSchedules().length === 0) {
    <app-not-found [(query)]="searchQuery">
      <p class="text-zinc-500">해당 연도에 등록된 방송 스케줄이 없습니다.</p>
    </app-not-found>
    } @else {
    <div class="event-list">
      @for (schedule of filteredSchedules(); track schedule.id) {
      <div class="event-card flex flex-col gap-4">
        <div class="event-card-header flex flex-col gap-2">
          <span
            [class]="
              'inline-flex items-center px-2.5 py-0.5 rounded-full w-fit text-xs font-medium ' +
              getStatusBadge(schedule.status).class
            ">
            {{ getStatusBadge(schedule.status).text }}
          </span>
          <h1 class="text-xl font-light">{{ schedule.programName }}</h1>
          <p class="text-sm text-zinc-500">{{ schedule.broadcaster }}</p>
        </div>
        <div class="h-px bg-zinc-200"></div>
        <div class="event-card-body">
          @if (schedule.event.title) {
          <div class="event-info">
            <app-icon name="solar:calendar-bold-duotone" class="size-4! text-zinc-300" />
            <span>{{ schedule.event.title }}</span>
          </div>
          }
          <div class="event-info">
            <app-icon name="material-symbols:videocam" class="size-4! text-zinc-300" />
            <span>촬영일: {{ formatSingleDate(schedule.shootingAt) }}</span>
          </div>
          <div class="event-info">
            <app-icon name="material-symbols:live-tv" class="size-4! text-zinc-300" />
            <span>방송일: {{ formatSingleDate(schedule.airAt) }}</span>
          </div>
          @if (schedule.broadcastUrl) {
          <a
            [href]="schedule.broadcastUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="event-info group cursor-pointer hover:text-primary-500 transition-colors"
            (click)="$event.stopPropagation()">
            <app-icon name="material-symbols:link" class="size-4! text-zinc-300 group-hover:text-primary-500" />
            <span class="group-hover:underline">방송 보기</span>
            <app-icon
              name="material-symbols:arrow-outward-rounded"
              class="size-4! text-zinc-400 group-hover:text-primary-500" />
          </a>
          } @else {
          <div class="event-info text-zinc-400">
            <app-icon name="material-symbols:link-off" class="size-4! text-zinc-300" />
            <span>방송 링크 준비중</span>
          </div>
          }
        </div>
      </div>
      }
    </div>
    }
  </div>
</div>
